import { ThemeColors } from '~/themes/colors'

interface ColorBlock {
  Background: ThemeColors
  FontColor: ThemeColors
  Border: ThemeColors
}

export interface BadgeColors {
  Blue: ColorBlock
  LightGray: ColorBlock
  Gray: ColorBlock
}

export const badgeColors: BadgeColors = {
  Blue: {
    Background: {
      default: 'achromatic.transparent',
    },
    FontColor: {
      default: 'blue.900',
    },
    Border: {
      default: 'blue.700',
    },
  },
  LightGray: {
    Background: {
      default: 'achromatic.transparent',
    },
    FontColor: {
      default: 'gray.800',
    },
    Border: {
      default: 'gray.600',
    },
  },
  Gray: {
    Background: {
      default: 'achromatic.transparent',
    },
    FontColor: {
      default: 'gray.1300',
    },
    Border: {
      default: 'gray.600',
    },
  },
}
